"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ForgottenPasswordPage = _interopRequireDefault(require("Pages/ForgottenPasswordPage"));
var _LoginPage = _interopRequireDefault(require("Pages/LoginPage"));
var _LoginPageOld = _interopRequireDefault(require("Pages/LoginPageOld"));
var _NotAllowedPage = _interopRequireDefault(require("Pages/NotAllowedPage"));
var _NotFoundPage = _interopRequireDefault(require("Pages/NotFoundPage"));
var _PasswordRecoveryPage = _interopRequireDefault(require("Pages/PasswordRecoveryPage"));
var _PublicUserFormPage = _interopRequireDefault(require("Pages/PublicUserFormPage"));
var _WelcomePage = _interopRequireDefault(require("Pages/WelcomePage"));
var _NewChatPage = _interopRequireDefault(require("Pages/Creation/NewChatPage"));
var _NewNewsPage = _interopRequireDefault(require("Pages/Creation/NewNewsPage"));
var _NewPagePage = _interopRequireDefault(require("Pages/Creation/NewPagePage"));
var _NewProjectPage = _interopRequireDefault(require("Pages/Creation/NewProjectPage"));
var _NewUserPage = _interopRequireDefault(require("Pages/Creation/NewUserPage"));
var _ChatPage = _interopRequireDefault(require("Pages/Front/ChatPage"));
var _ContactPage = _interopRequireDefault(require("Pages/Front/ContactPage"));
var _HomePage = _interopRequireDefault(require("Pages/Front/HomePage"));
var _ProjectsPage = _interopRequireDefault(require("Pages/Front/ProjectsPage"));
var _ChatsDashboardPage = _interopRequireDefault(require("Pages/Lists/ChatsDashboardPage"));
var _NewsDashboardPage = _interopRequireDefault(require("Pages/Lists/NewsDashboardPage"));
var _PagesDashboardPage = _interopRequireDefault(require("Pages/Lists/PagesDashboardPage"));
var _ProjectsDashboardPage = _interopRequireDefault(require("Pages/Lists/ProjectsDashboardPage"));
var _UsersDashboardPage = _interopRequireDefault(require("Pages/Lists/UsersDashboardPage"));
var _UpdateChatPage = _interopRequireDefault(require("Pages/Update/UpdateChatPage"));
var _UpdateNewsPage = _interopRequireDefault(require("Pages/Update/UpdateNewsPage"));
var _UpdatePagePage = _interopRequireDefault(require("Pages/Update/UpdatePagePage"));
var _UpdateProjectPage = _interopRequireDefault(require("Pages/Update/UpdateProjectPage"));
var _UpdateUserPage = _interopRequireDefault(require("Pages/Update/UpdateUserPage"));
var _default = exports.default = {
  ForgottenPasswordPage: _ForgottenPasswordPage.default,
  LoginPage: _LoginPage.default,
  LoginPageOld: _LoginPageOld.default,
  NotAllowedPage: _NotAllowedPage.default,
  NotFoundPage: _NotFoundPage.default,
  PasswordRecoveryPage: _PasswordRecoveryPage.default,
  PublicUserFormPage: _PublicUserFormPage.default,
  WelcomePage: _WelcomePage.default,
  NewChatPage: _NewChatPage.default,
  NewNewsPage: _NewNewsPage.default,
  NewPagePage: _NewPagePage.default,
  NewProjectPage: _NewProjectPage.default,
  NewUserPage: _NewUserPage.default,
  ChatPage: _ChatPage.default,
  ContactPage: _ContactPage.default,
  HomePage: _HomePage.default,
  ProjectsPage: _ProjectsPage.default,
  ChatsDashboardPage: _ChatsDashboardPage.default,
  NewsDashboardPage: _NewsDashboardPage.default,
  PagesDashboardPage: _PagesDashboardPage.default,
  ProjectsDashboardPage: _ProjectsDashboardPage.default,
  UsersDashboardPage: _UsersDashboardPage.default,
  UpdateChatPage: _UpdateChatPage.default,
  UpdateNewsPage: _UpdateNewsPage.default,
  UpdatePagePage: _UpdatePagePage.default,
  UpdateProjectPage: _UpdateProjectPage.default,
  UpdateUserPage: _UpdateUserPage.default
};
